import React from 'react';

const HomePage: React.FC = () => (
  <div>
    {/* Overview Section */}
    <section className="mb-8">
      <h2 className="font-bold mb-2">Overview</h2>
      <p className="text-black">
        money———machine is an AI program that assists with (a) discovery and
        (b) outreach for early-stage investment opportunities.
      </p>
    </section>

    {/* Discovery Section */}
    <section className="mb-8">
      <h2 className="font-bold mb-2">Discovery</h2>
      <p className="text-black">
        Each day at 5am PST, the program automatically downloads a new set
        of opportunities. Simply navigate to the Discovery tab and select a
        date from the drop-down menu to see all opportunities discovered that
        day.
      </p>
    </section>

    {/* Outreach Section */}
    <section>
      <h2 className="font-bold mb-2">Outreach</h2>
      <p className="text-black">
        If you find an interesting opportunity, you can enter the website or
        contact information in the Outreach tab, where it will dynamically
        produce an email for you. If the program has seen the website or email
        address before, it will automatically incorporate relevant stored
        metadata. If it has not seen the opportunity before, it will gather as
        much context as possible from the open internet.
      </p>
    </section>
  </div>
);

export default HomePage;
